// src/components/ProductModal.jsx

import React from "react";


const ProductModal = ({ selected, selectedSize, onClose }) => {
  if (!selected) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">

        <button className="close-btn" onClick={onClose}>×</button>

        <div className="modal-content">

          {/* LEFT: IMAGE + AVAILABLE SIZES */}
          <div className="modal-left">
            <img
              className="modal-img"
              src={selected.images[selectedSize]}
              alt={selected.name}
            />
            <p className="available-text">{selected.availableText}</p>
          </div>

          {/* RIGHT: FULL PRODUCT DETAILS */}
          <div className="modal-right">

            <h1 className="modal-title">{selected.name}</h1>

            <h3 className="modal-sub">{selected.detailsTitle}</h3>

            <p className="intro">{selected.introParagraph}</p>

            <h3 className="spec-heading">Specifications:</h3>

            <ul className="spec-list">
              {selected.specifications.map((spec, idx) => (
                <li key={idx}>{spec}</li>
              ))}
            </ul>

            <h3 className="why-head">{selected.whyTitle}</h3>

            <p className="why-desc">{selected.whyDescription}</p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default ProductModal;
